import { render } from "./PlayTogether.vue?vue&type=template&id=383eee04&scoped=true"
import script from "./PlayTogether.vue?vue&type=script&lang=js"
export * from "./PlayTogether.vue?vue&type=script&lang=js"

import "./PlayTogether.vue?vue&type=style&index=0&id=383eee04&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-383eee04"]])

export default __exports__